import axios from "axios";
import { api } from "../config";
import { toast } from "react-toastify";

// Create Axios instance
const apiClient = axios.create({
    baseURL: api.baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request Interceptor: Attach Token
apiClient.interceptors.request.use(
    (config) => {
        // Check if the request explicitly asks to skip auth
        if (config.skipAuth) {
            return config;
        }

        if (config.headers?.Authorization) {
            return config;
        }

        // Get token from localStorage (or wherever you persist it)
        // Note: user object in localStorage usually has the token
        const storedUser = localStorage.getItem("user");
        let token = null;

        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                // Try different common property names for token
                token = user.token || user.jwt || user.userToken;
            } catch (error) {
                console.error("Error parsing user from local storage", error);
            }
        }

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle 401
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("Session expired or unauthorized (401). Logging out...");

            // Clear local storage
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("user");

            // Clear specific chat items if needed (matching App.js logic)
            // It's cleaner to dispatch an event or call a global logout, 
            // but direct clearing works for immediate effect.
            // We can also trigger a custom event that App.js listens to.

            // Show toast
            toast.error("Session expired. Please login again.", {
                toastId: "session-expired"
            });

            // Redirect to login
            // Using window.location to ensure a full refresh/clear state
            // prevent infinite loop if already on login
            if (!window.location.pathname.includes("/login")) {
                setTimeout(() => {
                    window.location.href = "/login";
                }, 1500); // Small delay to let user see toast
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
